import KitActivationModal from './component'
export default KitActivationModal
